import clsx from 'clsx';
import React, { useContext } from 'react';
import { CommonSeparator } from './CommonSeparator';
import { BoxContext } from './Context';
import { BoxVariant } from './types';

export const DashedSeparator: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { variant } = useContext(BoxContext);
  return <CommonSeparator line={<DashedLine variant={variant} />}>{children}</CommonSeparator>;
};

const DashedLine: React.FC<React.PropsWithChildren<{ variant: BoxVariant }>> = ({
  children,
  variant,
}) => {
  return (
    <div className="h-1 w-full">
      <div
        className={clsx(
          'bg-gradient-to-l from-[transparent_50%]',
          variant === 'filled'
            ? 'to-[theme(colors.primary)_50%]'
            : 'to-[theme(colors.gray.100)_50%]',
          '[background-size:16px_100%]',
          'h-px w-full',
          variant === 'filled' && 'opacity-50'
        )}
      >
        {children}
      </div>
    </div>
  );
};
